@if (workspace && dataSourceId) {
  <div class="token-frequency-section">
    <div class="token-table-container">
      <div class="token-table-toolbar">
        <mat-slide-toggle
          class="lexicon-toggle"
          [(ngModel)]="showOnlyInLexicon"
          (change)="applyLexiconFilter()"
          >In Lexicon</mat-slide-toggle
        >
        <div class="ml-auto">
          <app-search-text
            (search)="onSearchChange($event)"
            [setPredicate]="false"
            [text]="'Filter Tokens'"
            class="mr-3"
          ></app-search-text>
        </div>
      </div>
      @if (tokenLoading || !tokenFrequencyData) {
        <div class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
          <span>Loading token frequency data...</span>
        </div>
      }
      @if (!tokenLoading && tokenFrequencyData) {
        <table
          mat-table
          [dataSource]="tokenFrequencyData"
          class="full-width-table token-table"
          matSort
        >
          <ng-container matColumnDef="token">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Token</th>
            <td mat-cell *matCellDef="let token">
              <mat-chip-set>
                <mat-chip
                  class="token-pill"
                  [class.token-pill--in-lexicon]="token?.existsInLexicon"
                  [class.token-pill--candidate]="!token?.existsInLexicon"
                  (click)="searchInSentences(token?.token?.toLowerCase())"
                  matTooltip="Click to search in sentences"
                  aria-label="Search token in sentences"
                  [innerHTML]="
                    token?.token?.toLowerCase() | highlightSearch: tokenSearch
                  "
                >
                </mat-chip>
              </mat-chip-set>
            </td>
          </ng-container>
          <ng-container matColumnDef="frequency">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Frequency</th>
            <td mat-cell *matCellDef="let token">{{ token?.frequency }}</td>
          </ng-container>
          <ng-container matColumnDef="token_pos">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>POS</th>
            <td mat-cell *matCellDef="let token">
              {{ token?.token_pos }}
            </td>
          </ng-container>
          <ng-container matColumnDef="existsInLexicon">
            <th mat-header-cell *matHeaderCellDef>Value</th>
            <td mat-cell *matCellDef="let token">
              <span class="lexicon-value">
                {{
                  token?.lexiconValue !== undefined ? token?.lexiconValue : "-"
                }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let token">
              @if (!token?.existsInLexicon && !readOnly) {
                <button
                  mat-icon-button
                  color="primary"
                  matTooltip="Add to Lexicon"
                  (click)="addTokenToLexicon(token)"
                >
                  <mat-icon>add_circle</mat-icon>
                </button>
              }
              @if (token?.existsInLexicon && !readOnly) {
                <button
                  mat-icon-button
                  color="accent"
                  matTooltip="Edit in Lexicon"
                  (click)="editTokenInLexicon(token)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="tokenDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: tokenDisplayedColumns"></tr>
        </table>
      }
      @if (
        !tokenLoading &&
        tokenFrequencyData &&
        tokenFrequencyData.data.length > 0
      ) {
        <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons>
        </mat-paginator>
      }
    </div>
  </div>
}
